export const faqItems = [
  {
    q: '《出轨同学会》是电视剧还是电影？',
    a: '它是韩国出品的剧情 / 爱情类系列电影，目前普遍以“第一部 / 第二部 / 第三部”的方式划分，因此本站的“分集剧情”是按“分部 / 回目”来梳理的。',
  },
  {
    q: '没看过前面的，能直接看吗？',
    a: '可以。每一部相对独立，单独看也能看懂；但按顺序观看，人物关系与情绪累积会更连贯。',
  },
  {
    q: '剧情主要是讲什么的？',
    a: '围绕“同学聚会”这一场景，讲成年人在婚姻倦怠、旧日情愫与信任危机之间的选择，属于偏现实、偏群像的题材。',
  },
  {
    q: '第一部和第二部有什么不同？',
    a: '第一部侧重情感与群像，把几条关系线同时铺开；第二部则转向带有讽刺色彩的骗财骗局，重心从“感情”变成“算计”。',
  },
  {
    q: '结局算是圆满的吗？',
    a: '系列结局偏向留白与冷收尾，不提供皆大欢喜的答案。它更希望观众自己判断，谁该为这些选择负责。',
  },
  {
    q: '适合什么类型的观众？',
    a: '偏好成人向、群像叙事与现实题材的观众。如果只想看轻松治愈的故事，可能会觉得基调偏冷。',
  },
  {
    q: '这里能看到片源吗？',
    a: '不能。本站只做剧情梳理与解析，不提供任何片源或下载，建议通过正规渠道观看正片。',
  },
];